export enum LEAD_TABS {
  NEWS = 'news',
  QUOTED = 'quoted',
}
